import React, { useRef, useState } from 'react';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import colors from 'styles/colors';
import Popover from '@mui/material/Popover';
import AvatarRemoveButton from './AvatarRemoveButton';

const AvatarFileButton = ({ hasAvatar, onImageChange }) => {
  const [showAvatarActions, setShowAvatarActions] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const fileInputRef = useRef(null);

  const handleOpenFileDialog = () => {
    fileInputRef.current.click();
  };

  const handleEditClick = (event) => {
    setAnchorEl(event.currentTarget);
    setShowAvatarActions(true);
  };

  const handleClose = () => {
    setShowAvatarActions(false);
    setAnchorEl(null);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      onImageChange(file);
    }
  };

  return (
    <div>
      <Button
        className="avatarChangeButton"
        variant="outlined"
        color="primary"
        onClick={handleEditClick}
      >
        <EditIcon color={colors.text.primary} />
      </Button>
      <Popover
        open={showAvatarActions}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        classes={{
          paper: 'avatarActionsMenu',
        }}
      >
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: 'none' }}
          accept="image/*"
          onChange={handleFileUpload}
        />
        <Button onClick={handleOpenFileDialog} className="avatarAction">
          Upload a photo
        </Button>
        <br />
        {
          hasAvatar && (
            <AvatarRemoveButton />
          )
        }
      </Popover>
    </div>
  );
};

export default AvatarFileButton;
